import{View}from'./View';export class Stream extends View{}